/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Landing_Cockpit_Shop_ChipInputs */

const tr_landing_cockpit_shop_chip = /** @type {(inputs: Landing_Cockpit_Shop_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`mağaza ${i?.index}`)
};

const en_landing_cockpit_shop_chip = /** @type {(inputs: Landing_Cockpit_Shop_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`store ${i?.index}`)
};

const de_landing_cockpit_shop_chip = /** @type {(inputs: Landing_Cockpit_Shop_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Shop ${i?.index}`)
};

const ru_landing_cockpit_shop_chip = /** @type {(inputs: Landing_Cockpit_Shop_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`магазин ${i?.index}`)
};

/**
* | output |
* | --- |
* | "store {index}" |
*
* @param {Landing_Cockpit_Shop_ChipInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_shop_chip = /** @type {((inputs: Landing_Cockpit_Shop_ChipInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_Shop_ChipInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_shop_chip(inputs)
	if (locale === "de") return de_landing_cockpit_shop_chip(inputs)
	if (locale === "ru") return ru_landing_cockpit_shop_chip(inputs)
	return tr_landing_cockpit_shop_chip(inputs)
});